import { useQuery } from '@tanstack/react-query';
import { getAgentCenter } from 'services/api/AgentCenterAPI';
import { queryKeys } from '../queryKeys';

export const useGetAgentCenter = () => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.agentCenter,
        queryFn: getAgentCenter,
    });
    return { agentCenterData: data, isAgentCenterLoading: isLoading, ...rest };
};
